import { Title } from "@mantine/core";
import { FilterableRecords } from "../components/records/RecordPill";

export const RecordsPage = () =>
    <>
        <Title>records</Title>
        <FilterableRecords/>
    </>